import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Login.css';
import useAuth, { useAuthContext } from '../hooks/useAuth';
import NewPasswordDialog from '../components/NewPasswordDialog';

async function loginUser(credentials) {
  console.log('loginUser:credentials: ', credentials);
  return fetch('/hadi/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

export default function Login() {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState('');
  const [userObject, setUserObject] = useState(null);
  const [showNewPasswordDialog, setShowNewPasswordDialog] = useState(false);
  const { login, forgotPassword } = useAuth();
  const { setUser, setToken } = useAuthContext();

  const handleSubmit = async (e) => {
    setIsSending(true);
    try {
      e.preventDefault();
      const user = await login(username, password);
      console.log('after Login: user:', user);
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setShowNewPasswordDialog(true);
        setUserObject(user);
      } else {
        const token = user?.signInUserSession?.idToken?.jwtToken;
        if (!token) {
          console.log('current user:', user);
          throw Error('JWT invalid or not found');
        }
        console.log('Login:setToken: =>', token);
        setToken(token);
        setUser(user);
        setIsSending(false);
      }
    } catch (err) {
      console.log('this did not happen due to: ', err);
      setError(err.message);
      setIsSending(false);
      if (err.code === 'PasswordResetRequiredException') {
        setShowNewPasswordDialog(true);
      }
    }
  };

  const handleForgotPassword = async () => {
    try {
      if (!username) {
        setError("Username can't be empty");
        return;
      } else {
        const result = await forgotPassword(username);
        console.log(result);
        alert(
          'A temporary access code was sent to your email. Use to set new password.'
        );
        setShowNewPasswordDialog(true);
      }
    } catch (e) {
      console.log('Error processing forgot password: ', e);
    }
  };

  const hasError = error && error.length > 0;
  return (
    <div className="container login-container">
      <div className="row">
        <div className="col-md-6 offset-md-3 login-form">
          <h3>Please Log In</h3>
          <form className="main-form">
            <div className="form-group">
              <input
                name="username"
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                placeholder="enter username..."
                required
                value={username}
                type="email"
                onChange={(e) => setUserName(e.target.value)}
              />
              <input
                name="password"
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                required
                value={password}
                type="password"
                placeholder="enter password..."
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="invalid-feedback">Please try again.</div>
            </div>

            <button onClick={handleSubmit} className="btn btn-primary w-100">
              {isSending ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                'Log In'
              )}
            </button>
            {hasError && <div className="text-danger">{error}</div>}
          </form>
          <a href="#" onClick={handleForgotPassword}>
            Forgot Password
          </a>
        </div>
      </div>
      <NewPasswordDialog
        show={showNewPasswordDialog}
        handleClose={() => setShowNewPasswordDialog(false)}
        username={username}
        user={userObject}
        oldPassword={password}
      />
    </div>
  );
}
